<main class="circle-gradient-1">
    <section class="breadcrumb-sec event-sec">
        <div class="container">
            <div class="row g-0">
                <div class="col-md-6">
                    <ul class="breadcrumb">
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events">Events</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li><a routerLink="/events" fragment="cultural">Cultural</a></li>
                        <li><i class="fa fa-angle-right"></i></li>
                        <li> Farewell Party</li>
                    </ul>
                    <div class="sec-title">
                        <h1><span>11th and 12th Farewell Party</span></h1>
                        <p>"A truly unforgettable event.
                            Celebrating journeys, friendships, and dreams, as our students step confidently into a
                            future full of possibilities." </p>
                    </div>

                </div>
            </div>
            <div class="breadcrumb-overlay overflow-hidden"
                style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-2.webp);">
            </div>
        </div>
    </section>
    <section class="section-lg">
        <div class="container">
            <div class="sec-title text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="demo-gallery">
                <ul appLightgallery>
                    <li class="grid-item1"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-1.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-1.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-1.webp">
                        </a>
                    </li>
                    <li class="grid-item2"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-2.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-2.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-2.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-3.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-3.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-3.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-4.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-4.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-4.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-5.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-5.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-5.webp">
                        </a>
                    </li>
                    <li class="grid-item3 d-none d-lg-block d-md-block"
                        data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-6.webp"
                        data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-6.webp">
                        <a href="#">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/farewell-party-6.webp">
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</main>
